import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogDto } from 'src/app/data/models/dto/generic-dialog.dto';

@Component({
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GenericDialogComponent implements OnInit {
  @Input() dialogInfo!: GenericDialogDto;
  @Output() onConfirm = new EventEmitter()

  constructor(@Inject(MAT_DIALOG_DATA) public data: GenericDialogDto) {}

  ngOnInit(): void {
    this.dialogInfo = this.data;
  }

  confirm() {
    this.onConfirm.emit()
  }
}
